<template>
  <v-toolbar fixed app clipped-left dark color="black">
    <v-toolbar-side-icon @click.stop="toggleDrawer" v-if="authenticated"></v-toolbar-side-icon>
    <v-toolbar-title>
      <router-link :to="{ path: '/' }" class="d-flex white--text">
        <img v-bind:src="'/static/assets/' + siteSettings.logo" height="48px">
      </router-link>
    </v-toolbar-title>
    <v-spacer></v-spacer>

    <!-- Authenticated -->
    <template v-if="authenticated">
      <progress-bar :show="busy"></progress-bar>

      <v-toolbar-items class="text-xs-center hidden-xs-only">
        <v-menu offset-y>
          <v-btn
            slot="activator"
            flat
          >
            <span class="mr-1">{{ user.name }}</span>
            <v-icon light>arrow_drop_down</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile @click.prevent="logout">
              <v-list-tile-title>{{ $t('logout') }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </template>

    <!-- Guest -->
    <template v-else>
      <v-toolbar-items  class="hidden-xs-only">
        <v-btn flat :to="{ name: 'login' }">{{ $t('login') }}</v-btn>
        <v-btn flat :to="{ name: 'register' }">{{ $t('register') }}</v-btn>
      </v-toolbar-items >
    </template>
  </v-toolbar>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    drawer: {
      type: Boolean,
      required: true
    }
  },

  data: () => ({
    busy: false
  }),

  computed: mapGetters({
    user: 'authUser',
    authenticated: 'authCheck',
    siteSettings: 'siteSettings',
    appName: 'siteName'
  }),

  methods: {
    toggleDrawer () {
      this.$emit('toggleDrawer')
    },
    async logout () {
      this.busy = true

      if (this.drawer) {
        this.toggleDrawer()
      }

      // Log out the user.
      await this.$store.dispatch('logout')
      this.busy = false

      // Redirect to login.
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style lang="stylus" scoped>

.toolbar__title .router-link-active
  text-decoration: none

</style>



// WEBPACK FOOTER //
// ToolBar.vue?3de49d9b